module.exports = __webpack_public_path__ + "static/media/instacollect.519ae1b3.svg";